import { apiGet } from './api';

export function listEmailLogs({ page = 1, limit = 10 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  return apiGet(`/api/logs?${params.toString()}`);
}

export function getEmailLog(id) {
  return apiGet(`/api/logs/${id}`);
}
